module.exports = __webpack_public_path__ + "static/img/xssr.7ef8e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/xssr.png
// module id = mByY
// module chunks = 1